module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/character-make-hair@2x-b70b1d170c31d18139d56580c409a89f.png";